import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccc732f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "filter-parameter-statuses__item"
}

import { computed, onMounted, PropType, ref } from "vue";
import { OptionItemModel } from "../../../models";
import {
  PopoverColorEnum,
  PopoverPositionEnum,
  TirPmIconView,
  TirPmPopover,
  TirPmTooltipElement,
} from "tir-components";
import {
  CancelledCircleIcon,
  DoneCircleIcon,
  EmptyStatusCircleIcon,
  InProgressCircleIcon,
  PauseCircleIcon,
  StartCircleIcon,
} from "tir-style-system/icons/solid";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterGlobalStatusesParameter',
  props: {
  /**Данные опции фильтра */
  item: {
    type: Object as PropType<OptionItemModel>,
    required: true,
  },
  /**Укороченная информация */
  isShortInfo: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;



/**Ссылка на дом элемента фильтра */
const $itemFilter = ref<InstanceType<typeof HTMLElement>>();

/**После рендера компонента */
onMounted(() => {
  props.item.Width = $itemFilter.value?.offsetWidth;
});
/**Отображение иконок глобальных статусов */
const showIconGlobalStatuses = computed(() => {
  const status = props.item.GlobalStatusType;

  switch (status) {
    case 5:
      return StartCircleIcon;
    case 4:
      return PauseCircleIcon;
    case 3:
      return CancelledCircleIcon;
    case 2:
      return InProgressCircleIcon;
    case 1:
      return DoneCircleIcon;
    case 0:
      return EmptyStatusCircleIcon;
  }
});

return (_ctx: any,_cache: any) => {
  return (__props.isShortInfo)
    ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), {
        key: 0,
        width: "max-content"
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", {
            ref_key: "$itemFilter",
            ref: $itemFilter
          }, _toDisplayString(__props.item.Name), 513)
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(showIconGlobalStatuses.value), {
            style: _normalizeStyle({ color: __props.item.Color }),
            class: "filter-parameter-statuses__icon"
          }, null, 8, ["style"]))
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(showIconGlobalStatuses.value), {
          style: _normalizeStyle({ color: __props.item.Color }),
          class: "filter-parameter-statuses__icon"
        }, null, 8, ["style"])),
        _createElementVNode("div", {
          style: _normalizeStyle({ color: __props.item.Color }),
          class: "filter-parameter-statuses__name"
        }, _toDisplayString(__props.item.Name), 5)
      ]))
}
}

})